import _extends from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
var __jsx = React.createElement;
import { Select } from "@mantine/core";
/** SDS-sized Mantine select with a single chevron and combobox search. */
export function FormSelect(props) {
  return /*#__PURE__*/React.createElement(Select, _extends({
    size: "sm"
  }, props));
}